import Slideout from 'slideout';
import Handorgel from 'handorgel';
import Glide from '@glidejs/glide';
import FloatLabels from 'float-labels.js';
import Cookies from 'js-cookie';
import ExploreBlock from './components/ExploreBlock';
import NavBarSearch from './components/NavBarSearch';
import ShareOverlay from './components/ShareOverlay';
import SimpleAccordion from './components/SimpleAccordion';

( function () {
    window.Cookies = Cookies;

// Product Taxonomy & Specifications Accordion
    if ( document.getElementsByClassName( 'handorgel' ).length > 0 ) {
        let taxAccordion = new Handorgel( document.querySelector( '.handorgel' ) );
        taxAccordion.on( 'fold:opened', ( fold ) => {
            console.log( fold );
            fold.content.style.height = 'auto';
        } );
        taxAccordion.folds[ 0 ].open();
    }

// Mega Carousel Module
    if ( document.getElementsByClassName( 'glide' ).length > 0 ) {
        new Glide( '.glide', {
            autoplay: false,
            type: 'slide',
            animationDuration: 800,
            animationTimingFunc: 'cubic-bezier(0.19, 1, 0.22, 1)',
            startAt: 0,
            perView: 1,
            gap: 0,
        } ).on( 'build.after', () => {
            // @TODO Think we should make this specific to each glide instance in the future to support multiple sliders on a page
            let slides = document.querySelectorAll( '.glide__slide' );
            let tallestSlide = 0;
            console.log( slides );
            slides.forEach( ( slide ) => {
                let height = jQuery( slide ).outerHeight();
                if ( height > tallestSlide ) {
                    tallestSlide = height;
                }
            } );

            jQuery( '.glide__track' ).css( 'height', tallestSlide );
            slides.forEach( ( slide ) => {
                jQuery( slide ).css( 'height', tallestSlide );
            } );

        } ).mount();
    }

    const masthead = document.querySelector( '#masthead' );

// Mobile Nav Menus
    let mobileNavMenu = document.getElementById( 'menu' );
    if ( mobileNavMenu ) {
        const slideout = new Slideout( {
            'panel': document.getElementById( 'panel' ),
            'menu': mobileNavMenu,
            'padding': 256,
            'tolerance': 70,
            'easing': 'cubic-bezier(0.19, 1, 0.22, 1)',
            'duration': 300,
            'side': 'right',
            'touch': false,
        } );

        document.querySelector( '#menu-hamburger' ).addEventListener( 'click', () => {
            slideout.toggle();
        } );
    }

// Mobile Nav Accordion Menus
    for ( const el of document.querySelectorAll( ".mobile-nav__accordion" ) ) {
        new Handorgel( el, {
            headerOpenClass: 'mobile-nav__submenu--open',
            headerOpenedClass: 'mobile-nav__submenu--opened',
        } );
    }

// Primary nav accordion
    const desktopAccordions = [];
    for ( const el of document.querySelectorAll( ".primary-nav__accordion" ) ) {
        let accordion = new Handorgel( el, {
            headerOpenClass: 'primary-nav__submenu--open',
            headerOpenedClass: 'primary-nav__submenu--opened',
        } );

        desktopAccordions.push( accordion );

        accordion.on( 'fold:open', ( fold ) => {
            console.log( 'fold' );
            desktopAccordions.forEach( ( accordion ) => {
                accordion.folds[ 0 ].close();
            } );
            // Handle closing menu when the user clicks away from the main navigation
            jQuery( 'html' ).click( function ( e ) {
                const clickEventNavElement = e.target.classList[ 0 ];
                if ( clickEventNavElement !== ( 'primary-nav__parent-button' || 'primary-nav__link' || 'primary-nav__arrow' ) ) {
                    accordion.folds[ 0 ].close();
                }
            } );
        } );
    }

// ============================ //
//  UNIVERSAL MODAL CONTROLLER  //
// ============================ //

// MODAL METADATA & METHODS
    class Modal {
        constructor( name, image, title, bio, linkedin, phone ) {
            this.name = name;
            this.title = title;
            this.bio = bio;
            this.image = image;
            this.phone = phone;
            //this.email = email;
            this.linkedin = linkedin;
        }

        // 3. Show Overlay & Prevent Page Scrolling
        static Create( card, wrapper, $modalBody ) {
            wrapper.classList.add( 'modal-show' );
            $modalBody.classList.add( 'active' );
            Modal.Parse( card, $modalBody );
        }

        // 4. Parse Current Modal Data
        static Parse( card ) {
            const $linkedin = card.querySelector( 'a' )[ 'href' ],
                //$email = card.querySelectorAll('input')[0].value,
                $image = card.querySelector( 'img' )[ 'src' ],
                $title = card.querySelector( 'p' ).innerHTML,
                $phone = card.querySelectorAll( 'input' )[ 0 ].value,
                $name = card.querySelector( 'h2' ).innerHTML,
                $bio = card.querySelector( 'img' )[ 'alt' ];
            const $keys = new Modal( $name, $image, $title, $bio, $linkedin, $phone );
            Modal.Add( Object.entries( $keys ) );
        }

        // 5. Add Data to Current Modal
        static Add( $keys ) {
            // Modal Container
            const $parent = document.querySelector( '.modal' );
            const $wrapper = document.getElementById( "modal__wrapper" );
            const $closeButton = document.createElement( "div" );
            $closeButton.className = "modal__close";
            const $modalImage = document.getElementById( "modal__image" );
            const $modalLabel = document.getElementById( "modal__label" );
            const $modalContactList = document.getElementById( "modal__contact" );
            const $modalContactNumber = document.getElementById( "modal__number" );
            const $modalBio = document.getElementById( "modal__bio" );

            $parent.appendChild( $wrapper );
            $wrapper.appendChild( $closeButton );


            for ( const [ label, value ] of $keys ) {
                let $parent = document.querySelector( '.modal' );
                let el = document.createElement( "div" );
                const context = document.createTextNode( value );

                // Image
                if ( label === "image" ) {
                    $parent = $modalImage;
                    el = document.createElement( "div" );
                    el.setAttribute( "style", `background-image: url(${value}); background-size:cover;` )
                }

                // LinkedIn Icon
                if ( label === "linkedin" ) {
                    $parent = $modalContactList;
                    el = document.createElement( "a" );
                    el[ 'target' ] = "_blank";
                    el[ 'href' ] = value;
                }

                // Email
                if ( label === "email" ) {
                    $parent = $modalContactList;
                    el = document.createElement( "a" );
                    // TODO: Make sure that the value string is stripped of any domain which is not superior essex
                    //       and also checks to make sure there are no duplicate domains "example@essex.com@essex.com"
                    el[ 'href' ] = `mailto:${value}`;
                }

                if ( label === "phone" ) {
                    $parent = $modalContactNumber;
                    el = document.createElement( "a" );
                    el[ 'href' ] = `tel:${value}`;
                    //el['innerText'] = `${value}`;
                }

                // Name + Title
                if ( label === "name" || label === "title" ) {
                    $parent = $modalLabel;
                    el = document.createElement( "p" );
                    el.appendChild( context );
                }

                // Bio
                if ( label === "bio" ) {
                    $parent = $modalBio;
                    el = document.createElement( "p" );
                    el.appendChild( context );
                }

                // Attach all elements to DOM
                el.classList.add( `modalValue_${label}` );
                $parent.appendChild( el );
            }
        }

        // 6. Remove all data from modal and destroy it
        static Destroy( $modalBody ) {
            $modalBody.forEach( field => field.remove() );
        }
    }

    const postArray = document.getElementsByClassName( 'post-gallery__item' );

// 2. CREATE OR DESTROY MODAL
    const handleClick = ( wrapper, overlay, body ) => {
        // Card click event handler
        Array.from( postArray ).forEach( card => {
            card.addEventListener( 'click', () => {
                // Show Overlay & Prevent Page Scrolling
                Modal.Create( card, wrapper, body );
            }, false );
        } );
        if (overlay) {
            // Dismiss modal & overlay if the overlay is clicked.
            overlay.addEventListener( 'click', () => {
                wrapper.classList.remove( 'modal-show' );
                const All = document.querySelectorAll( "[class^=modalValue]" );
                // Remove all data from modal and destroy it
                Modal.Destroy( All );
            } );
        }
    };

// 1. MODAL INIT
    if ( postArray ) {
        const $modalBody = document.querySelector( '.modal' ),
            $modalOverlay = document.querySelector( '#modal-overlay' ),
            $modalWrapper = document.querySelector( 'body' );
        handleClick( $modalWrapper, $modalOverlay, $modalBody );
    }

// Explore Blocks
    const exploreBlocks = [];
    for ( const el of document.querySelectorAll( ".explore-block" ) ) {
        let exploreBlock = new ExploreBlock( el );
        exploreBlocks.push( exploreBlock );
    }

// Float Labels
    let floatlabels = new FloatLabels( '.gform_wrapper form', {

        customPlaceholder: function ( placeholderText, el, labelEl ) {
            if ( el.options ) {
                return '';
            } else {
                return placeholderText;
            }
        },
    } );

// Filter Bar Search
    for ( const el of document.querySelectorAll( "#filter-bar" ) ) {
        let filterBar = new FilterBarSearch( el );
    }

    let navBarSearchEl = document.getElementById( 'navbar-search' );
    if ( navBarSearchEl ) {
        let navBarSearch = new NavBarSearch( navBarSearchEl );
    }

// Share Overlay
    window.shareOverlay = false;
    let shareOverlayEl = document.getElementById( 'share-overlay' );
    if ( shareOverlayEl ) {
        window.shareOverlay = new ShareOverlay( shareOverlayEl );
    }

    for ( const el of document.querySelectorAll( '#share-button' ) ) {
        el.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            shareOverlay.open();
        } );
    }

    for ( const el of document.querySelectorAll( '.simple-accordion' ) ) {
        let simpleAccordion = new SimpleAccordion( el );
    }
} )();